<template>
  <div class="footer-nav">
    <van-tabbar
      v-model="active"
      active-color="#7c6ff0"
      :border="false"
      inactive-color="#9ca3af"
      z-index="999"
    >
      <van-tabbar-item to="/Home">
        <span>{{ $t("foorter.index") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
            :alt="$t('foorter.index')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Video">
        <span>{{ $t("foorter.subscribe") }} </span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
            :alt="$t('foorter.subscribe')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Certification">
        <span>{{ $t("foorter.certification") }}</span>
        <template #icon="props">
          <span class="certification-icon" :class="{ active: props.active }">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2.8 19 5.5v5.8c0 4.5-2.8 8.3-7 10-4.2-1.7-7-5.5-7-10V5.5l7-2.7Z" />
              <path d="m8.8 12 2.1 2.1 4.5-4.6" />
            </svg>
          </span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Choose">
        <span>{{ $t("foorter.xuanfei") }}</span>
        <template #icon="props">
          <img :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'" :alt="$t('foorter.xuanfei')" class="tab-icon" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Mine">
        <span>{{ $t("foorter.my") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'"
            :alt="$t('foorter.my')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    };
  },
  watch: {
    $route(to) {
      this.updateActive(to);
    },
  },
  created() {
    this.updateActive(this.$route);
  },
  methods: {
    updateActive(route) {
      const routeMap = {
        '/home': 0,
        '/video': 1,
        '/certification': 2,
        '/choose': 3,
        '/mine': 4,
      };
      const idx = routeMap[(route.path || '').toLowerCase()];
      if (idx !== undefined) {
        this.active = idx;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 100px;

.footer-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  height: calc(@tabbar-height + env(safe-area-inset-bottom));

  .van-tabbar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999 !important;
    height: calc(@tabbar-height + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-top: none;
    box-shadow: 0 -4px 24px rgba(31, 41, 55, 0.06);
  }

  .van-tabbar-item {
    font-size: 22px;

    .tab-icon {
      height: 48px;
      width: 48px;
      object-fit: contain;
      transition: transform 0.2s ease;
    }

    .certification-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      border-radius: 15px;
      background: #eef0f5;
      color: #8b93a3;
      font-size: 34px;
      transition: all .2s ease;

      svg {
        width: 32px;
        height: 32px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.9;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      &.active {
        color: #fff;
        background: linear-gradient(135deg, #7c6ff0, #db6ea9);
        box-shadow: 0 6px 14px rgba(124,111,240,.3);
        transform: scale(1.08);
      }
    }

    &.van-tabbar-item--active {
      .tab-icon {
        transform: scale(1.08);
      }
    }
  }
}
</style>
